export default __webpack_public_path__ + "static/media/FLOP.961fce5c.wav";